module.exports = __webpack_public_path__ + "img/buy-icon5-en.6e9768b.png";